import { MouseEvent, useRef } from 'react';

export const useBackdropClose = (onClose: () => void) => {
    const pressTarget = useRef<EventTarget>(null);

    return {
        onMouseDown: (event: MouseEvent<HTMLElement>) => {
            pressTarget.current = event.target;
        },
        onClick: (event: MouseEvent<HTMLElement>) => {
            if (event.target === event.currentTarget && event.target === pressTarget.current) {
                onClose();
            }
        },
    };
};
